module.exports = __webpack_public_path__ + "static/media/Avenir-Black.d10ab385.ttf";